export default "__VITE_ASSET__ab4f4319__"